<template>
  <div>
    <div class="jumbotron">

      <div class="btn-group pull-right" role="group" aria-label="Reset pg stats on a data source">
        <button type="button" class="btn btn-sm btn-primary" @click="refreshRows" v-if="hostname && hostnameApp">
          <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
        </button>
        <!-- <button type="button" class="btn btn-sm btn-secondary" @click="showPgStatReset">
          <i class="fa fa-times" aria-hidden="true"></i> Reset Stats
        </button> -->
      </div>

      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
        <li class="breadcrumb-item active">DB Spy</li>
      </ol>

      <div class="row">
        <div class="col-md-6">
          <div class="card card-inverse card-info text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Display details of a Helium apps performance</p>
              </blockquote>
              <i aria-hidden="true" class="fas fa-mobile-alt card-block-watermark"></i>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card card-inverse card-success text-xs-center">
            <div class="card-block">
              <blockquote class="card-blockquote">
                <p>Display overview of datasource performance</p>
              </blockquote>
              <i aria-hidden="true" class="fa fa-database card-block-watermark"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <form>
          <fieldset>
            <div class="form-group">
              <div class="input-group">
                <label class="col-3 col-form-label"><i class="fas fa-eye"></i> DB Spy viewing mode: </label>
                <select v-model="selectedMode" class="custom-select form-control">
                  <option>App</option>
                  <option>Datasource</option>
                </select>
              </div>
              <small class="form-text text-muted">Select DB Spy mode, view results for entire datasource or for one Helium app</small>
              <div class="input-group">
                <label class="col-3 col-form-label"><i class="fas fa-database"></i> Data Source</label>
                <select v-model="dataSource" class="custom-select form-control">
                  <option disabled value="">Please select a data source</option>
                  <option v-for="entry in dataSources" v-bind:value="entry.dataSource">
                      {{ entry.dataSource.heliumDataSourceName }}
                  </option>
                </select>
              </div>
              <small class="form-text text-muted">Helium data source to be examined</small>
              <div class="input-group" v-if="selectedMode === 'App'">
                <label class="col-3 col-form-label"><i class="fas fa-mobile-alt"></i> App</label>
                <select
                  v-model="hostnameApp"
                  placeholder="Helium App"
                  type="text"
                  class="custom-select form-control">
                  <option disabled value="">Please select an app</option>
                  <option v-for="a in hostnameApps">
                      {{a.name}} ( {{a.id}} )
                  </option>
                </select>
              </div>
              <small class="form-text text-muted" v-if="selectedMode === 'App'">Helium App on selected data source to be examined.</small>
            </div>
          </fieldset>
        </form>
<!--         <blockquote class="blockquote">
          <div v-if="dataSources.length > 0">
            <form>
              <fieldset>
                <div class="form-group">
                  <div class="input-group">
                    <label class="col-4 col-form-label">Data Source</label>
                    <select v-model="dataSource" class="custom-select form-control">
                      <option disabled value="">Please select a data source</option>
                      <option v-for="entry in dataSources" v-bind:value="entry.dataSource">
                          {{ entry.dataSource.heliumDataSourceName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-group">
                    <label class="col-4 col-form-label">App</label>
                    <select
                      v-model="hostnameApp"
                      placeholder="Helium App"
                      type="text"
                      class="custom-select form-control">
                      <option disabled value="">Please select an app</option>
                      <option v-for="a in hostnameApps">
                          {{a.name}} ( {{a.id}} )
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group pull-right">
                  <div class="input-group">
                    <button type="button" class="btn btn-sm btn-secondary" @click="resetData">
                      <i class="fa fa-times" aria-hidden="true"></i> Clear selection
                    </button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </blockquote> -->
      </div>
      <!-- <div class="col">
        <div id="schema-access-info" class="alert alert-info pull-right" role="alert">
          <i class="fa fa-info-circle" aria-hidden="true"></i>
          <strong>Postgres Stats</strong><br>
          <p>Query stats are retrieved by the postgres module pg_stat_statements and filtered by Helium App</p>
          <p v-if="lastResetStr">{{ lastResetStr }}</p>
        </div>
      </div> -->
    </div>

    <ul class="nav nav-tabs" v-if="dataSource">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#chart">Chart</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#table">Table</a>
      </li>
    </ul>
    <div class="tab-content" v-if="dataSource">
      <div class="tab-pane fade active show" id="chart">
        <div class="row">
          <div class="col-6">
            <form>
              <fieldset>
                <div class="form-group">
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-pie-chart" aria-hidden="true"></i> Chart Metric
                    </label>
                    <select class="form-control" v-model="chartType">
                      <option disabled value="">Please select a chart metric</option>
                      <option v-for="entry in chartTypeDropdown">
                          {{ entry.label }}
                      </option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-sort" aria-hidden="true"></i> Sort
                    </label>
                    <select class="form-control" v-model="chartSortType">
                      <option disabled value="">Please select a sort type</option>
                      <option>
                        Ascending
                      </option>
                      <option>
                        Descending
                      </option>
                    </select>
                  </div>
                  <div class="input-group">
                    <label class="col-4 col-form-label">
                      <i class="fa fa-sort-numeric-asc" aria-hidden="true"></i> Number of results
                    </label>
                    <select class="form-control" v-model="chartResultSetSize">
                      <option disabled value="">Please select a number of results</option>
                      <option v-for="i in chartResultSetSizes">
                        {{ i }}
                      </option>
                    </select>
                  </div>
                </div>
              </fieldset>
            </form>
            <div v-if="chartData">
              <pie-chart
                :chartData="chartData"
                :options="{responsive: true, maintainAspectRatio: true}">
              </pie-chart>
            </div>
          </div>
          <div class="col-6">
            <div v-if="chartData" v-for="entry in chartQueries">
              <pre v-highlightjs="entry"><code class="sql"></code></pre>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="table">
        <div class="row">
          <div class="col">
            <div v-if="!loading && rows.length > 0">
              <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :sort-options="{
                    enabled: true,
                    initialSortBy: {field: 'mean_time', type: 'desc'}
                  }"
                  :search-options="{ enabled: true }"
                  :paginationOptions="{ enabled: true }"
                  @on-row-click="onClickFn"
                  styleClass="vgt-table striped bordered table-hover"
                  :lineNumbers="true">
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'query'">{{ props.row.query }}</span>
                  <span v-if="props.column.field == 'calls'">{{ props.row.calls }}</span>
                  <span v-if="props.column.field == 'total_time'">{{ props.row.total_time }}</span>
                  <span v-if="props.column.field == 'min_time'">{{ props.row.min_time }}</span>
                  <span v-if="props.column.field == 'max_time'">{{ props.row.max_time }}</span>
                  <span v-if="props.column.field == 'mean_time'">{{ props.row.mean_time }}</span>
                  <span v-if="props.column.field == 'stddev_time'">{{ props.row.stddev_time }}</span>
                  <span v-if="props.column.field == 'rows'">{{ props.row.rows }}</span>
                </template>
              </vue-good-table>
            </div>
            <div class="row"
              v-if="loading">
              <div class="col d-flex justify-content-center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalResetShow"
      :backdrop="modalBackdrop"
      effect="zoom"
      large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-times" aria-hidden="true"></i> Reset Stats on Data Source
        </h4>
      </div>
      <div slot="modal-body" class="modal-body">

        <form>
          <fieldset>
            <div class="form-group">
              <div class="input-group">
                <label class="col-4 col-form-label">Data Source</label>
                <select v-model="hostnameReset" class="custom-select form-control">
                    <option disabled value="">Please select a data source</option>
                    <option v-for="entry in hostnames">
                        {{ entry.hostname }}
                    </option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <label class="col-4 col-form-label text-danger">Enter RESET in capital letters</label>
                <input v-model="resetConfirmText"
                  class="form-control"
                  type="text">
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-btn-primary" @click="pgStatReset" :disabled="resetDisabled">Reset Stats on server</button>
        <button type="button" class="btn btn-default" @click="closePgStatReset">Close</button>
      </div>
    </modal>

    <modal
      :show.sync="modalShowDetail"
      :backdrop="modalBackdrop"
      effect="zoom"
      large>
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <i class="fa fa-info" aria-hidden="true"></i> Query Pattern Detail
        </h4>
      </div>
      <div slot="modal-body" class="modal-body" v-if="selectedQuery">
        <pre v-highlightjs="selectedQuery.query"><code class="sql"></code></pre>
        <form>
          <fieldset>
            <div class="form-group">
              <div class="input-group">
                <label class="col-6 col-form-label">Number of Calls</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.calls" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Total Time spend processing</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.total_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Minimum Time query has lasted</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.min_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Maximum Time query has lasted</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.max_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Mean Time spend processing query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.mean_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Standard deviation of time processing query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.stddev_time" readonly="true" />
              </div>
              <div class="input-group">
                <label class="col-6 col-form-label">Total Rows retrieved or affected by query</label>
                <input class="form-control col-2" type="text" v-model="selectedQuery.rows" readonly="true" />
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-default" @click="closeModalShowDetail">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
  import PieChart from '@/components/PieChart.vue'
  import { modal } from 'vue-strap'
  export default {
    components: {
      modal,
      PieChart
    },
    data () {
      return {
        loading: false,
        hostnames: [],
        hostname: null,
        hostnameReset: null,
        hostnameApps: [],
        hostnameApp: null,
        columns: [
          {
            label: 'Query',
            field: 'query',
            filterable: true
          },
          {
            label: 'Calls',
            field: 'calls',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Total Time',
            field: 'total_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Min Time',
            field: 'min_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Max Time',
            field: 'max_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Mean Time',
            field: 'mean_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Standard Deviation',
            field: 'stddev_time',
            filterable: true,
            type: 'number'
          },
          {
            label: 'Rows retrieved or affected',
            field: 'rows',
            filterable: true,
            type: 'number'
          }
          // ,
          // {
          //   label: 'shared_blks_hit',
          //   field: 'shared_blks_hit',
          //   filterable: true
          // },
          // {
          //   label: 'shared_blks_read',
          //   field: 'shared_blks_read',
          //   filterable: true
          // },
          // {
          //   label: 'shared_blks_dirtied',
          //   field: 'shared_blks_dirtied',
          //   filterable: true
          // },
          // {
          //   label: 'shared_blks_written',
          //   field: 'shared_blks_written',
          //   filterable: true
          // },
          // {
          //   label: 'local_blks_hit',
          //   field: 'local_blks_hit',
          //   filterable: true
          // },
          // {
          //   label: 'local_blks_read',
          //   field: 'local_blks_read',
          //   filterable: true
          // },
          // {
          //   label: 'local_blks_dirtied',
          //   field: 'local_blks_dirtied',
          //   filterable: true
          // },
          // {
          //   label: 'local_blks_written',
          //   field: 'local_blks_written',
          //   filterable: true
          // },
          // {
          //   label: 'temp_blks_read',
          //   field: 'temp_blks_read',
          //   filterable: true
          // },
          // {
          //   label: 'temp_blks_written',
          //   field: 'temp_blks_written',
          //   filterable: true
          // },
          // {
          //   label: 'blk_read_time',
          //   field: 'blk_read_time',
          //   filterable: true
          // },
          // {
          //   label: 'blk_write_time',
          //   field: 'blk_write_time',
          //   filterable: true
          // }
        ],
        rows: [],
        modalResetShow: false,
        modalBackdrop: false,
        resetDisabled: true,
        resetConfirmText: null,
        lastReset: null,
        lastResetStr: null,
        modalShowDetail: false,
        selectedQuery: null,
        chartOptions: null,
        chartData: null,
        chartType: 'Mean Time',
        chartSortType: 'Descending',
        chartQueries: [],
        chartResultSetSize: 5,
        dataSources: [],
        dataSource: null,
        selectedMode: 'App'
      }
    },
    methods: {
      getDatabaseServers: function () {
        let vm = this
        vm.$parent.environment.dataSources.forEach(function (key) {
          vm.pingDatabase(key)
        })
      },
      pingDatabase: function (dataSource) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/ping-database'
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = dataSource
        vm.axios.post(endpoint, config)
          .then(function (response) {
            var element = {}
            element['heliumDataSourceName'] = dataSource.heliumDataSourceName
            element['response'] = response.data.response
            element['dataSource'] = dataSource
            vm.dataSources.push(element)
          })
          .catch(function (error) {
            var element = {}
            element['heliumDataSourceName'] = dataSource.heliumDataSourceName
            element['response'] = error.response.data.response
            vm.dataSources.push(element)
          })
      },
      getDatabaseHostApps: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/schema-access/app-schemas'

        let config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = vm.dataSource

        vm.loading = true
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.hostnameApps = response.data
            vm.loading = false
            vm.$parent.loading = false
            if (vm.hostnameApps.length <= 0) {
              vm.$Simplert.open({ title: 'Info', message: 'No database servers found on ' + endpoint, type: 'info' })
            }
          })
          .catch(function (error) {
            vm.loading = false
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
          })
      },
      getPgStats: function (config) {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/stats'
        vm.loading = true
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.loading = false
            vm.$parent.loading = false
            vm.rows = response.data
            if (vm.rows.length <= 0) {
              vm.$Simplert.open({ title: 'Info', message: 'No postgres statement stats found on ' + endpoint, type: 'info' })
            }
            vm.maybeUpdateChartData()
          })
          .catch(function (error) {
            vm.loading = false
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Info', message: error, type: 'info' })
          })
      },
      getPgStatsDatasource: function () {
        let vm = this
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['dataSource'] = vm.dataSource
        vm.getPgStats(config)
      },
      getPgStatsForApp: function (appId) {
        let vm = this
        var config = {}
        config['environment'] = vm.$parent.environment.name
        config['appId'] = appId
        vm.getPgStats(config)
      },
      pgStatReset: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/schema-access/api/pgStatReset/?hostname=' + vm.hostnameReset
        var config = {}
        config['hostname'] = vm.hostnameReset
        vm.loading = true
        vm.$parent.loading = true
        vm.axios.post(endpoint, config)
          .then(function (response) {
            vm.rows = response.data
            vm.loading = false
            vm.$parent.loading = false
            vm.closePgStatReset()
            vm.resetData()
          })
          .catch(function (error) {
            vm.loading = false
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
            vm.closePgStatReset()
          })
      },
      pgStatLastReset: function () {
        let vm = this
        let endpoint = vm.$parent.baseUrl + '/portal-backend/api/db-spy/last-reset'
        vm.loading = true
        vm.$parent.loading = false
        vm.axios.post(endpoint)
          .then(function (response) {
            vm.lastReset = response.data
            vm.loading = false
            vm.$parent.loading = false
          })
          .catch(function (error) {
            vm.loading = false
            vm.$parent.loading = false
            vm.$Simplert.open({ title: 'Error', message: error, type: 'error' })
          })
      },
      showPgStatReset: function () {
        let vm = this
        vm.modalResetShow = true
      },
      closePgStatReset: function () {
        let vm = this
        vm.modalResetShow = false
      },
      resetData: function () {
        let vm = this
        vm.rows = []
        vm.hostnameApps = []
        vm.hostname = null
        vm.hostnameApp = null
      },
      refreshRows: function () {
        let vm = this
        if (vm.hostnameApp) {
          var appId = vm.hostnameApp.split('( ').pop().split(' )').shift()
          vm.getPgStatsForApp(appId)
        }
      },
      onClickFn: function (row, index) {
        let vm = this
        vm.selectedQuery = row
        vm.modalShowDetail = true
      },
      closeModalShowDetail: function () {
        let vm = this
        vm.modalShowDetail = false
      },
      setChartData: function () {
        let vm = this

        vm.chartQueries = []

        let chartLabels = []
        let chartDataElements = []
        let chartColours = []
        let chartDatasets = []

        let chartTypeField = vm.formatChartTypeLabelToField(vm.chartType)

        // Sort desc by chart type
        let rowsData = this.rows.slice().sort(
          function (a, b) {
            if (vm.chartSortType === 'Ascending') {
              return a[chartTypeField] - b[chartTypeField]
            } else if (vm.chartSortType === 'Descending') {
              return b[chartTypeField] - a[chartTypeField]
            }
          }
        )
        for (var i = 0; i < vm.chartResultSetSize && i < rowsData.length; i++) {
          var ele = rowsData[i]
          chartLabels.push('#' + (i + 1) + ' ' + chartTypeField)
          let suffix = chartTypeField === 'total_time' || chartTypeField === 'min_time' || chartTypeField === 'max_time' || chartTypeField === 'mean_time' || chartTypeField === 'stddev_time' ? 's' : ''
          vm.chartQueries.push('-- Query #' + (i + 1) + '\n' + ele.query + '\n-- Value:\n' + ele[chartTypeField] + suffix + ' ' + vm.chartType)
          chartDataElements.push(ele[chartTypeField])
          chartColours.push(vm.getRandomColor())
        }
        chartDatasets.push({
          backgroundColor: chartColours,
          data: chartDataElements
        })
        vm.chartData = {
          labels: chartLabels,
          datasets: [
            {
              backgroundColor: chartColours,
              data: chartDataElements
            }
          ]
        }
      },
      getRandomColor: function () {
        var letters = '0123456789ABCDEF'
        var color = '#'
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      },
      maybeUpdateChartData: function () {
        let vm = this
        if (vm.chartType !== null && vm.chartSortType !== null && vm.chartResultSetSize != null) {
          vm.setChartData()
        }
      },
      formatChartTypeLabelToField: function (value) {
        let vm = this
        if (vm.chartType === null) {
          return null
        }
        let result = null
        vm.columns.slice().filter(function (item) {
          return item.label === value
        }).forEach(function (element) {
          result = element.field
        })
        return result
      }
    },
    created () {
      let vm = this
      vm.getDatabaseServers()
      vm.pgStatLastReset()
      window.addEventListener('keydown', function (e) {
        if (e.keyCode === 27) {
          vm.closeModalShowDetail()
          vm.closePgStatReset()
        }
      })
    },
    mounted () {
    },
    beforeDestroy: function () {
    },
    watch: {
      'dataSource': function (newValue) {
        let vm = this
        if (newValue) {
          vm.getDatabaseHostApps()
          vm.lastReset.forEach(function (key) {
            if (key.databaseHost.toUpperCase().replace(/_/g, '-') === newValue.toUpperCase()) {
              vm.lastResetStr = 'Stats last reset on ' + newValue + ' last reset at ' + key.lastReset
            }
          })
          if (vm.selectedMode === 'Datasource') {
            vm.getPgStatsDatasource()
          }
        }
      },
      'hostnameApp': function (newValue) {
        let vm = this
        if (newValue) {
          var appId = newValue.split('( ').pop().split(' )').shift()
          vm.getPgStatsForApp(appId)
        }
      },
      selectedMode: function (newValue) {
        this.dataSource = null
        this.hostnameApp = null
      },
      'resetConfirmText': function (newValue) {
        let vm = this
        if (newValue === 'RESET') {
          vm.resetDisabled = false
        } else {
          vm.resetDisabled = true
        }
      },
      'chartType': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      },
      'chartSortType': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      },
      'chartResultSetSize': function (newValue) {
        let vm = this
        vm.maybeUpdateChartData()
      }
    },
    computed: {
      chartTypeDropdown: function () {
        let vm = this
        return vm.columns.slice().filter(function (item) {
          return item.field !== 'query'
        })
      },
      chartResultSetSizes: function () {
        let values = []
        for (var i = 5; i <= this.rows.length; i = i + 5) {
          values.push(i)
        }
        return values
      }
    }
  }
</script>

<style scoped>
  #chart {
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// PgStats.vue?310b709b